import React, {useState} from 'react'
import { Box, Typography, Container, Grid, styled } from '@mui/material'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import FAQRenterItemComponent from './faq-item'
import FAQOwnerItemComponent from './faq-item-owner'

const TopBox = styled(Box)({
  
  padding: '50px 0',
  
  '& .context': {
    width: '100%',
    '& h5': {
        color: '#6E8C20',
        fontSize: 18,
        lineHeight: '33px',
        fontFamily: 'Bayon',
        fontWeight: 'normal',
        margin: 0,
    },

    '& h1': {
        color: '#323232',
        fontSize: 72,
        lineHeight: '82px',
        fontFamily: 'Inter',
        fontWeight: 600,
        margin: 0,
        '& span': {
          color: '#6E8C20',
        },
        '@media only screen and (min-width: 320px) and (max-width: 768px)': {
          fontSize: 26,
          lineHeight: '36px'
        },
    },

    '& .tab-section':{
      padding: '40px 0 0',

      '& .MuiBox-root': {
        padding: 0,
        '& .MuiAccordionSummary-root':{
          padding: '0px 0px',
          '& p':{
            color: '#323232',
            fontSize: 18,
            lineHeight: '21px',
            fontFamily: 'Inter',
            fontWeight: '600'
          },
        },
        '& .MuiAccordionDetails-root':{
          padding: '0px 0px',
          '& p':{
            color: '#323232',
            fontSize: 15,
            lineHeight: '24px',
            fontFamily: 'Inter',
            fontWeight: '500'
          }
        }
      }
    },

    '& .MuiButtonBase-root.MuiTab-root':{
      border: 'solid 1px #E2E2E2',
      background: '#FFF',
      borderRadius: 20,
      width: 97,
      height: 41,
      padding: 0,
      minHeight: 'auto',
      marginRight: 20,
      textTransform: 'capitalize',

      '&.Mui-selected':{
        border: 'solid 1px #6E8C20',
        background: '#6E8C20',
        color: '#FFF',
        fontSize: 14,
        lineHeight: '24px',
        fontFamily: 'Inter',
      }
    },

    '& .MuiTabs-indicator':{
      display: 'none'
    }
    
  },
  '@media only screen and (min-width: 320px) and (max-width: 768px)': {
    padding: '20px 0',
    '& .context': {
      
      '& h5': {
          fontSize: 14,
          lineHeight: '25px',
          fontWeight: 'normal'
      },
  
      '& h1': {
          fontSize: 26,
          lineHeight: '36px',
      },
  
      '& .tab-section':{
        padding: '20px 0 0',
  
        '& .MuiBox-root': {
          padding: 0,
          '& .MuiAccordionSummary-root':{
            padding: '0px 0px',
            '& p':{
              fontSize: 15,
              lineHeight: '18px',
            },
          },
          '& .MuiAccordionDetails-root':{
            padding: '0px 0px',
            '& p':{
              fontSize: 14,
              lineHeight: '20px',
            }
          }
        }
      },
  
      '& .MuiButtonBase-root.MuiTab-root':{
        border: 'solid 1px #E2E2E2',
        background: '#FFF',
        borderRadius: 20,
        width: 97,
        height: 41,
        padding: 0,
        minHeight: 'auto',
        marginRight: 20,
        textTransform: 'capitalize',
  
        '&.Mui-selected':{
          border: 'solid 1px #6E8C20',
          background: '#6E8C20',
          color: '#FFF',
          fontSize: 14,
          lineHeight: '24px',
          fontFamily: 'Inter',
        }
      },
  
      '& .MuiTabs-indicator':{
        display: 'none'
      }
      
    },
  }
})

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const FAQComponentSection = () => {
  const [value, setValue] = useState(1);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div className='faq-container'>
      <TopBox>
        <Container>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12}>
              <div className='context'>
                  <h5>FAQ’s</h5>
                  <h1><span>Addressing your</span><br /> farming needs.</h1>
                  <div className='tab-section'>
                    <Tabs value={value} onChange={handleChange} aria-label="disabled tabs example">
                      <Tab label="Renter" />
                      <Tab label="Owner" />
                    </Tabs>
                    <CustomTabPanel value={value} index={0}>
                      <FAQRenterItemComponent />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                      <FAQOwnerItemComponent />
                    </CustomTabPanel>
                    </div>
              </div>
            </Grid>  
          </Grid>    
        </Container>
      </TopBox>
    </div>
  )
}

export default FAQComponentSection;
